var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',_vm._l((_vm.value),function(requisiteCondition,index){return _c('div',{key:index},[_c('RequisiteAdvanceConditions',{class:{'py-3 border-b':_vm.level===1},attrs:{"value":requisiteCondition}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }